var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActivityCompleted(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7685 0.0614537C10.839 0.0211821 10.9188 0 11 0C11.0812 0 11.161 0.0211821 11.2315 0.0614537L17.7648 3.79504C17.8362 3.83584 17.8956 3.8948 17.9369 3.96594C17.9782 4.03708 18 4.11787 18 4.20014V4.87218C18 9.10234 15.1953 12.821 11.1279 13.9821C11.0443 14.006 10.9557 14.006 10.8721 13.9821C8.89252 13.4165 7.15099 12.2214 5.91107 10.5777C4.67114 8.93401 4.00028 6.93115 4 4.87218V4.20014C4.00003 4.11787 4.02179 4.03708 4.0631 3.96594C4.1044 3.8948 4.16377 3.83584 4.2352 3.79504L10.7685 0.0614537ZM10.6005 9.99747L14.6307 4.95806L13.9027 4.37562L10.4661 8.67018L8.032 6.6419L7.43467 7.35875L10.6005 9.99747Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1333 6.7304C16.1333 9.35043 13.8351 11.4744 11 11.4744C8.16494 11.4744 5.86667 9.35043 5.86667 6.7304C5.86667 4.11038 8.16494 1.98643 11 1.98643C13.8351 1.98643 16.1333 4.11038 16.1333 6.7304Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1333 5.30721C16.1333 6.09322 15.5065 6.7304 14.7333 6.7304C13.9601 6.7304 13.3333 6.09322 13.3333 5.30721C13.3333 4.5212 13.9601 3.88402 14.7333 3.88402C15.5065 3.88402 16.1333 4.5212 16.1333 5.30721Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1106 3.73359L10.6894 8.44141L8.66667 6.3318L7.73333 7.02076L10.844 10.2674L15.2 4.42255L14.1106 3.73359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7997 1.00287C10.8608 0.967392 10.9299 0.94873 11.0003 0.94873C11.0706 0.94873 11.1398 0.967392 11.2009 1.00287L16.8631 4.29226C16.925 4.3282 16.9764 4.38015 17.0122 4.44282C17.048 4.5055 17.0669 4.57668 17.0669 4.64915V5.24124C17.0669 8.96811 14.6362 12.2443 11.1111 13.2673C11.0386 13.2883 10.9619 13.2883 10.8894 13.2673C9.17378 12.769 7.66446 11.7161 6.58985 10.268C5.51525 8.81982 4.93384 7.05525 4.93359 5.24124V4.64915C4.93362 4.57668 4.95248 4.5055 4.98828 4.44282C5.02408 4.38015 5.07553 4.3282 5.13743 4.29226L10.7997 1.00287ZM10.6541 9.75675L14.1468 5.3169L13.5159 4.80376L10.5376 8.58737L8.42799 6.80041L7.9103 7.43197L10.6541 9.75675Z",
    fill: "#00AF3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4491 6.87838C15.4491 9.18669 13.4573 11.0579 11.0003 11.0579C8.54321 11.0579 6.55137 9.18669 6.55137 6.87838C6.55137 4.57007 8.54321 2.69882 11.0003 2.69882C13.4573 2.69882 15.4491 4.57007 15.4491 6.87838Z",
    fill: "#00AF3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4491 5.62451C15.4491 6.31701 14.9059 6.87838 14.2358 6.87838C13.5657 6.87838 13.0225 6.31701 13.0225 5.62451C13.0225 4.93202 13.5657 4.37064 14.2358 4.37064C14.9059 4.37064 15.4491 4.93202 15.4491 5.62451Z",
    fill: "#00AF3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6961 4.23811L10.7311 8.38582L8.97804 6.5272L8.16915 7.13419L10.865 9.99454L14.6403 4.84511L13.6961 4.23811Z",
    fill: "#00AF3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1097 3.79517L10.6885 8.50299L8.66576 6.39337L7.73242 7.08233L10.843 10.3289L15.1991 4.48413L14.1097 3.79517Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 22,
    height: 22,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityCompleted);
export default __webpack_public_path__ + "static/media/activityCompleted.ece3ee45ce8488c4dfac58f3f6db546d.svg";
export { ForwardRef as ReactComponent };